import {keys} from "lodash";

export const getMetaDatabase = (entities) => {
    return keys(entities).reduce((metaDatabase, entity) => {
        return {...metaDatabase,
            [entity]: {
                _all_: {
                    loading: false,
                    includes: null,
                    error: ''
                }
            }
        };
    }, {});
}
